module.exports = __webpack_public_path__ + "img/target4.7346c6dd.jpg";